export default class Modal {
    modal: HTMLDivElement;
    dialog: HTMLDivElement;

    constructor() {
        this.modal = document.createElement('div');
        this.modal.id = "modal";
        this.modal.classList.add("modal");

        this.dialog = document.createElement('div');
        this.dialog.id = "dialog";
        this.dialog.classList.add("modal__dialog");

        document.addEventListener("click", this.close);
    }

    public open(innerHtml: string) {
        this.dialog.innerHTML = innerHtml;
        this.modal.prepend(this.dialog);
        document.body.prepend(this.modal);
    }

    public close(e: MouseEvent) {
        const modal = document.getElementById("modal");
        if (e.target === modal) { modal?.remove() }
    }
}
